import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactTooltip from "react-tooltip";
import * as c from '../../constants';
import * as actions from '../../actions';
import MiniLoader from '../../../common/components/MiniLoader';
import CmsContext from '../../../../context/CmsContext';

function StatsComponent({ getCounts, counts }) {
  const cmsContext = useContext(CmsContext);
  const { transactions_human, tax_payers, residents, transactions } = counts;

  const CMS_ICONS = cmsContext.findByType('ICONS');

  const cmsIcons = {
    registrants: _.get(CMS_ICONS, 'CORE_REGISTRANT.cdnUrl'),
    transactionsIcn: _.get(CMS_ICONS, 'CORE_TRANSACTION.cdnUrl'),
    residentsIcn: _.get(CMS_ICONS, 'CORE_RESIDENTS.cdnUrl'),
    nonResidents: _.get(CMS_ICONS, 'CORE_NON_RESIDENTS.cdnUrl'),
  };

  useEffect(() => {
    getCounts();
  }, []);

  const STATS_ITEM = { margin: '4px -4px', borderRadius: '8px' }
  const STATS_STYLE = { fontSize: '14px', fontWeight: '500' }
  const STATS_NUM_STYLE = { fontSize: '20px', fontWeight: '500' }

  return (
    <div className="stats-container row">
      <div className="stats-item col-lg-3 px-2">
        <div className="stats-item-inner mx-0 item-box-shadow" data-tip="" data-for="total-registrant" style={STATS_ITEM}>
          <div className="stats-item-title text-truncate overflow-hidden" style={STATS_STYLE}>
            <span className="animate-truncated-text w-100">
              Total Registrants
            </span>
            <ReactTooltip place="top" id="total-registrant" type="dark" effect="float" delayShow="300">
              Total Registrants
            </ReactTooltip>
          </div>
          <div className="stats-item-no-wrapper">
            <div className="stats-item-icon">
              {!_.isEmpty(CMS_ICONS) ? (
                <img src={cmsIcons.registrants} alt="" />
              ) : (
                <MiniLoader />
              )}
            </div>
            <div className="stats-item-numbers" style={STATS_NUM_STYLE}>
              {_.get(tax_payers, 'count')
                ? _.get(tax_payers, 'count').toLocaleString()
                : 0}
            </div>
          </div>
        </div>
      </div>
      <div className="stats-item col-lg-3 px-2">
        <div className="stats-item-inner mx-0 item-box-shadow" data-tip="" data-for="total-real-property-units" style={STATS_ITEM}>
          <div className="stats-item-title text-truncate overflow-hidden" style={STATS_STYLE}>
            <span className="animate-truncated-text w-100">
              Total Real Property Units
            </span>
            <ReactTooltip id="total-real-property-units" place="top" type="dark" effect="float" delayShow="300">
              Total Real Property Units
            </ReactTooltip>
          </div>
          <div className="stats-item-no-wrapper">
            <div className="stats-item-icon">
              {!_.isEmpty(CMS_ICONS) ? (
                <img src={cmsIcons.transactionsIcn} alt="" />
              ) : (
                <MiniLoader />
              )}
            </div>
            <div className="stats-item-numbers" style={STATS_NUM_STYLE}>
              {transactions_human ? transactions_human.toLocaleString() : 0}
            </div>
          </div>
        </div>
      </div>
      <div className="stats-item col-lg-3 px-2">
        <div className="stats-item-inner mx-0 item-box-shadow" data-tip="" data-for="total-business-establishments" style={STATS_ITEM}>
          <div className="stats-item-title text-truncate overflow-hidden" style={STATS_STYLE}>
            <span className="animate-truncated-text w-100">
              Total Business Establishments
            </span>
            <ReactTooltip id="total-business-establishments" place="top" type="dark" effect="float" delayShow="300">
              Total Business Establishments
            </ReactTooltip>
          </div>
          <div className="stats-item-no-wrapper">
            <div className="stats-item-icon">
              {!_.isEmpty(CMS_ICONS) ? (
                <img src={cmsIcons.residentsIcn} alt="" />
              ) : (
                <MiniLoader />
              )}
            </div>
            <div className="stats-item-numbers" style={STATS_NUM_STYLE}>
              {_.get(residents, 'count')
                ? _.get(residents, 'count').toLocaleString()
                : 0}
            </div>
          </div>
        </div>
      </div>
      <div className="stats-item col-lg-3 px-2">
        <div className="stats-item-inner mx-0 item-box-shadow" data-tip="" data-for="total-ohp-permit" style={STATS_ITEM}>
          <div className="stats-item-title text-truncate overflow-hidden" style={STATS_STYLE}>
            <span className="animate-truncated-text w-100">
              Total Cedula Count
            </span>
            <ReactTooltip id="total-ohp-permit" place="top" type="dark" effect="float" delayShow="300">
              Total Cedula Count
            </ReactTooltip>
          </div>
          <div className="stats-item-no-wrapper">
            <div className="stats-item-icon">
              {!_.isEmpty(CMS_ICONS) ? (
                <img src={cmsIcons.nonResidents} alt="" />
              ) : (
                <MiniLoader />
              )}
            </div>
            <div className="stats-item-numbers" style={STATS_NUM_STYLE}>
              {_.get(transactions, 'CDL')
                ? _.get(transactions, 'CDL').toLocaleString()
                : 0}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

StatsComponent.defaultProps = {
  counts: {},
};

StatsComponent.propTypes = {
  getCounts: PropTypes.instanceOf(Function).isRequired,
  counts: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  counts: _.get(api, `${c.GET_COUNTS}.res`),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(StatsComponent);
